var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list"},[_c('event-list2',{attrs:{"activeCard":_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }